"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Platform = /*#__PURE__*/function () {
  function Platform() {
    _classCallCheck(this, Platform);

    this.html = $('html');
    this.iHeight = window.screen.height;
    this.iWidth = window.screen.width;
  }

  _createClass(Platform, [{
    key: "isIE",
    value: function isIE() {
      return this.html.data('isIe') === true;
    }
  }, {
    key: "isEdge",
    value: function isEdge() {
      return this.html.data('isEdge') === true;
    }
  }, {
    key: "isSafari",
    value: function isSafari() {
      return this.html.data('isSafari') === true;
    }
  }, {
    key: "isDesktop",
    value: function isDesktop() {
      return this.html.data('device') === 'desktop';
    }
  }, {
    key: "isTablet",
    value: function isTablet() {
      return this.html.data('device') === 'tablet';
    }
  }, {
    key: "isPhone",
    value: function isPhone() {
      return this.html.data('device') === 'phone';
    }
  }, {
    key: "deviceModel",
    value: function deviceModel() {
      var oldIphonesCondition = this.iWidth === 375 && this.iHeight === 667 || this.iWidth === 320 && this.iHeight === 568 || this.iWidth === 320 && this.iHeight === 480;
      var oldIpadsCondition = this.iWidth === 768 && this.iHeight === 1024;

      if (oldIphonesCondition || oldIpadsCondition) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "iOSDevice",
    value: function iOSDevice() {
      var deviceIphone = navigator.userAgent.match(/iPhone;/i) ? true : false;
      var deviceIpad = navigator.userAgent.match(/iPad;/i) ? true : false;

      if (deviceIphone === true || deviceIpad === true) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return Platform;
}();